import React from "react";
import { connect } from "react-redux";
import clsx from "clsx";

import { makeStyles } from "@material-ui/core/index";
import EditStop from "./EditStop/EditStop";
import EditVehicle from "./EditVehicle/EditVehicle";
import Unscheduled from "./Unscheduled/Unscheduled";
import { remCalc } from "../../utils/helpers";
import DriversList from "./DriversList/DriversList";

const useStyles = makeStyles(theme => ({
  root: {
    position: "absolute",
    width: remCalc(448),
    top: 0,
    bottom: 0,
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#fff",
    boxShadow: theme.variables.boxShadow,
    opacity: 1,
    visibility: "visible",
    transition:
      "transform .2s ease-in-out," +
      "opacity .2s ease-in-out," +
      "visibility .2s ease-in-out;",
    left: remCalc(448),
  },
  panelClosed: {
    transform: "translateX(-100%)",
    opacity: 0,
    visibility: "hidden"
  },
  panelDeepClosed: {
    transform: "translateX(-150%)",
    opacity: 0,
    visibility: "hidden"
  }
}));

function ExtendablePanel({ drawerOpen, editType, expanded, setExpanded }) {
  const classes = useStyles();

  return (
    <div
      className={clsx(classes.root, {
        [classes.panelClosed]: !editType,
        [classes.panelDeepClosed]: !drawerOpen
      })}
    >
      {/* Stop */}
      {editType === "stops" && <EditStop />}

      {/* Vehicle */}
      {editType === "vehicles" && (
        <EditVehicle expanded={expanded} setExpanded={setExpanded} />
      )}

      {/* Unscheduled */}
      {editType === "unscheduled" && <Unscheduled />}

      {/* Drivers */}
      {editType === "drivers" && <DriversList />}
    </div>
  );
}

function mapStateToProps(state) {
  return {
    drawerOpen: state.common.drawerOpen,
    editType: state.extendable.type
  };
}

export default connect(mapStateToProps, {})(ExtendablePanel);
